import storesTab from "./storesTab";
import dailyLimits from "./dailyLimits";
import networkRegions from "./networkRegions";

export default {
    namespaced: true,
    modules: {
        storesTab,
        dailyLimits,
        networkRegions
    }
};
